import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';
import type { ActivityFeedShipmentTooltip as ActivityFeedShipmentTooltipModel } from '../utils/activityFeedPhrase.types';

interface ActivityFeedShipmentTooltipProps {
  tooltip: ActivityFeedShipmentTooltipModel;
}

const ActivityFeedShipmentTooltip = ({ tooltip }: ActivityFeedShipmentTooltipProps) => {
  const { translate } = useTranslation();
  const { carrier, latestStatus, latestDate } = tooltip;

  return (
    <Stack sx={{ gap: 0.25 }}>
      {carrier && (
        <Typography variant="body2" color="inherit" sx={{ lineHeight: 'normal' }}>
          {translate(LangEnum.ACTIVITY_FEED_ORDER_SHIPMENT_TOOLTIP_CARRIER, { carrier })}
        </Typography>
      )}
      {latestStatus && (
        <Typography variant="body2" color="inherit" sx={{ lineHeight: 'normal' }}>
          {translate(LangEnum.ACTIVITY_FEED_ORDER_SHIPMENT_TOOLTIP_LATEST_STATUS, {
            status: translate(latestStatus.label),
            date: latestDate,
          })}
        </Typography>
      )}
    </Stack>
  );
};

ActivityFeedShipmentTooltip.displayName = 'ActivityFeedShipmentTooltip';
export default ActivityFeedShipmentTooltip;
